import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./OverviewSection.module.scss";
import { RefObject } from "react";
import { ESectionOptions } from "@/frontend/widgets/Sidebar";
import { OverviewByInnovera, OverviewByInnoveraProps } from "./OverviewByInnovera/OverviewByInnovera";
import { SectionTitle } from "../Section/SectionTitle/SectionTitle";

type OverviewSectionUnclaimedProps = {
  className: string;
  innerRef: RefObject<HTMLDivElement>;
} & OverviewByInnoveraProps;

export function OverviewSectionUnclaimed({ className, innerRef, ...props }: OverviewSectionUnclaimedProps) {
  return (
    <div className={className}>
      <div className={styles.container}>
        <div className={styles.refContainer} data-section={ESectionOptions.OVERVIEW} ref={innerRef}>
          <div className={styles.contentContainer}>
            <div className={styles.titleContainer}>
              <SectionTitle>Overview</SectionTitle>
            </div>
            <OverviewByInnovera {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}
